import { Box, BoxProps } from '@chakra-ui/react';

export type RoundedBoxProps = {
  center?: boolean;
} & BoxProps;

const RoundedBox = ({ center, ...props }: RoundedBoxProps) => (
  <Box
    width="full"
    borderRadius="10px"
    padding="10px"
    {...props}
    display={center ? 'flex' : undefined}
    alignItems={center ? 'center' : undefined}
    flexDirection={center ? 'column' : undefined}
  />
);

export default RoundedBox;
